import { AlertTriangleFilledIcon } from '@/components/icons/AlertTriangleFilledIcon';
import { COLORS } from '@/styles/tokens/colors';

export interface DefaultWarningIndicatorProps {
  isIconVariant: boolean;
  size?: number;
}

export function DefaultWarningIndicator({
  isIconVariant,
  size = 16,
}: DefaultWarningIndicatorProps) {
  if (!isIconVariant) {
    return (
      <AlertTriangleFilledIcon
        size={size}
        color={COLORS.FUNCTIONAL.WARNING.DEFAULT}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      />
    );
  }

  return (
    <div
      style={{
        backgroundColor: COLORS.FUNCTIONAL.WARNING[50],
        padding: 4,
        borderRadius: 4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <AlertTriangleFilledIcon
        size={size}
        color={COLORS.FUNCTIONAL.WARNING.DEFAULT}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      />
    </div>
  );
}
